module.exports = __webpack_public_path__ + "static/media/CtaBackground.9e2da6c0.png";